import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { queryPolicies } from "@sx/api-client";
import { EmptyState, Icon } from "@sx/ui";

import { Region } from "../../../components/Region";
import { organizations } from "../../../lib/account";
import { useAuthQueryKey } from "../../../lib/query-keys";
import { RouteFallback } from "../../../shell/RouteFallback";
import { OrganizationBillingDashboard } from "../../../workspaces/settings/OrganizationBillingDashboard";

export const Route = createFileRoute(
  "/_console/settings/organizations/$organizationId_/billing",
)({
  component: OrganizationBillingRoute,
});

function OrganizationBillingRoute() {
  const key = useAuthQueryKey();
  const { organizationId } = Route.useParams();
  const rows = useQuery({
    queryKey: key("organizations"),
    queryFn: organizations,
    ...queryPolicies.reference,
  });
  return (
    <Region
      query={rows}
      title="Organizations"
      placeholder={
        <RouteFallback />
      }
    >
      {(organizationRows) => {
        const organization = organizationRows.find((row) => row.id === organizationId);
        if (!organization) {
          return (
            <EmptyState
              icon={<Icon name="organization" />}
              title="Organization unavailable"
              hint="Choose an organization from the avatar menu."
            />
          );
        }
        return <OrganizationBillingDashboard organization={organization} />;
      }}
    </Region>
  );
}
